import React, { Component } from 'react';
import Copyright from '../componentes/copyright';
import Principal from '../componentes/principal';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography'
import Consultadisponibilidade from '../componentes/consultadisponibilidadeveiculo';
import { Container } from '@material-ui/core';
import Link from '@material-ui/core/Link';

const classes = makeStyles((theme) => ({
   paper: {
     marginTop: theme.spacing(8),
     display: 'flex',
     flexGrow: 1,
     flexDirection: 'column',
     alignItems: 'center',
   },
   title: {
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
}));

document.title = 'Frota UFSM'
document.logo=''

class PageInit extends Component {
   
  
 render(){
return(
 
<Container >
      <div id="cabeça" >
      <Principal/>
      
      
      </div>
      
      <Container  maxWidth='md'>
      <div id="corpo" mt={3} className={classes.paper} align="center" >
<br></br>
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Seja Bem Vindo!
          </Typography>
          <br></br>

          <Consultadisponibilidade/>
<br></br>
          
          
      </div>
      <div mt={3} className={classes.paper} align="center">
      <Typography className={classes.title} variant="h5" noWrap align="center">
            Vídeos Tutoriais
          </Typography>

          <br></br>

        <Link target="_blank" href="https://drive.google.com/file/d/1YEINvRp46_rnGGnmr84nzgPX5U_nbfWQ/view?usp=sharing">
         
        Adicione um local ao Google Maps 
         
         </Link>
         <br></br>
          
         <br></br>
         Para Usuários
         <br></br>
         <br></br>

        <Link target="_blank" href="https://drive.google.com/file/d/1KBrCVxGMfQmSRNH2F8BB04wgKOVSBmZ5/view?usp=sharing">
         
        01- Solicitar deslocamento 
         
         </Link>
         <br></br>

         <Link target="_blank" href="https://drive.google.com/file/d/1iPmnmm_0U6mwrt3Er6SmVdzZdF8YsJSL/view?usp=sharing">
         
        02- Gerenciar minha solicitação 
         
         </Link>

         <br></br>

        <Link target="_blank" href="https://drive.google.com/file/d/1Bme78ke9rMkRHxyJCU07y7HCPypI6YtA/view?usp=sharing">

        03- Acompanhar deslocamento em andamento 

        </Link>
                <br></br>

         <Link target="_blank" href="https://drive.google.com/file/d/1TGA1ugBJUM2h1qtjmRuOWdtZ0j-GRcVe/view?usp=sharing">
         
        04- Encerrar minha solicitação 
         
         </Link>
         <br></br>
         <br></br>
         Para Chefes de Unidades/Departamentos
         <br></br>
         <br></br>
         <Link target="_blank" href="https://drive.google.com/file/d/1WNKWJ4B8aOEGnsmE_gvfMHuvAMCbN7uU/view?usp=sharing">
         
        05- Ativar/Desativar um usuário
         
         </Link>
         <br></br>

         <Link target="_blank" href="https://drive.google.com/file/d/15xr3HsTROPiXFL1UCwdZi7PYY18xm6pm/view?usp=sharing">
         
        06- Gerenciar Solicitações
         
         </Link>
{/*
         <br></br>

         <Link target="_blank" href="https://drive.google.com/file/d/15ghvp4Y_MvGbnCjL-VgtMlBimbSlvi9_/view?usp=sharing">
         
        07- Acompanhar um deslocamento em andamento
         
         </Link>
*/}

      </div>
       </Container>
  
       <Box mt={3}>
          <Copyright/>
       </Box>
   
   
   </Container>
)}

}

 
 
export default PageInit;
